import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatTableDataSource, PageEvent, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-bitacora-general',
  templateUrl: './bitacora-general.component.html',
  styleUrls: ['./bitacora-general.component.scss']
})
export class BitacoraGeneralComponent implements OnInit {

  loading: boolean = false;
  filtroOrden: string = '';
  filtroTecnico: any = null;
  filtroFechaInicio: Date = null;
  filtroFechaFin: Date = null;
  filtroProvincia: any = null;
  filtroTipoOrden: any = null;

  tecnicos: any[] = [];
  tecnicosFiltrados: any[] = [];
  searchTecnico: string = '';
  provincias: any[] = [];
  tiposOrden: any[] = [
    { id: 41, nombre: 'Instalación' },
    { id: 44, nombre: 'Falla' }
  ];

  displayedColumns: string[] = [
    'orden', 'tipo_orden', 'fecha_cita', 'locacion', 'tecnico', 'tel_tecnico',
    'supervisor', 'tel_supervisor', 'contrata', 'hora_salida', 'hora_sitio',
    'hora_finaliza', 'tiempo_en_sitio', 'fecha_llamada', 'tipo_contacto',
    'motivo', 'resultado', 'estado_orden', 'tipologia', 'subtipologia',
    'observaciones', 'nombre_usuario'
  ];
  dataSource = new MatTableDataSource<any>([]);
  totalRegistros: number = 0;
  pageSize: number = 10;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private gateway: GatewayService,
    private localSave: LocalSaveService,
    private snackbar: MatSnackBar
  ) {}

  ngOnInit() {
    this.cargarFiltros();
    // Fecha por defecto: hoy
    this.filtroFechaInicio = new Date();
    this.filtroFechaFin = new Date();
    this.buscar();
  }

  cargarFiltros(): void {
    // Provincias
    this.gateway.get('getprovincias', { IDPAIS: 5 }).then((res: any) => {
      this.provincias = res.rows || res || [];
    }).catch(() => {});

    // Tecnicos
    this.gateway.get('gettecnicosbitacora', {}).then((res: any) => {
      this.tecnicos = res.rows || [];
      this.tecnicosFiltrados = this.tecnicos.slice();
    }).catch(() => {});
  }

  buscar(): void {
    this.loading = true;
    if (this.paginator) this.paginator.firstPage();
    this.cargarDatos(1);
  }

  cargarDatos(pagina: number): void {
    this.loading = true;
    this.gateway.get('historicobitacorageneral', {
      ORDEN: this.filtroOrden || null,
      IDAGENTE: this.filtroTecnico || null,
      FECHA_INICIO: this.filtroFechaInicio ? this.formatDate(this.filtroFechaInicio) : null,
      FECHA_FIN: this.filtroFechaFin ? this.formatDate(this.filtroFechaFin) : null,
      IDPROVINCIA: this.filtroProvincia || null,
      TIPO_ORDEN: this.filtroTipoOrden || null,
      PAGINA: pagina,
      TAMANO: this.pageSize
    }).then((res: any) => {
      this.dataSource.data = res.rows || [];
      this.totalRegistros = res.total || 0;
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  }

  onPageChange(event: PageEvent): void {
    this.cargarDatos(event.pageIndex + 1);
  }

  filtrarTecnicos(): void {
    const term = (this.searchTecnico || '').toLowerCase();
    this.tecnicosFiltrados = this.tecnicos.filter(t => (t.nombre || '').toLowerCase().indexOf(term) > -1);
  }

  onTecnicoDropdownToggle(opened: boolean): void {
    if (opened) {
      this.searchTecnico = '';
      this.tecnicosFiltrados = this.tecnicos.slice();
    }
  }

  limpiar(): void {
    this.filtroOrden = '';
    this.filtroTecnico = null;
    this.filtroFechaInicio = null;
    this.filtroFechaFin = null;
    this.filtroProvincia = null;
    this.filtroTipoOrden = null;
  }

  formatDate(d: Date): string {
    const yyyy = d.getFullYear();
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return `${yyyy}-${mm}-${dd}`;
  }

  formatFecha(fecha: any): string {
    if (!fecha) return '';
    const d = new Date(String(fecha));
    if (isNaN(d.getTime())) return String(fecha);
    const dd = ('0' + d.getDate()).slice(-2);
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const yyyy = d.getFullYear();
    const hh = ('0' + d.getHours()).slice(-2);
    const min = ('0' + d.getMinutes()).slice(-2);
    return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
  }

  descargar(): void {
    if (this.totalRegistros === 0) return;
    const totalPaginas = Math.ceil(this.totalRegistros / this.pageSize) || 1;
    const promesas = [];
    for (let i = 1; i <= totalPaginas; i++) {
      promesas.push(this.gateway.get('historicobitacorageneral', {
        ORDEN: this.filtroOrden || null,
        IDAGENTE: this.filtroTecnico || null,
        FECHA_INICIO: this.filtroFechaInicio || null,
        FECHA_FIN: this.filtroFechaFin || null,
        IDPROVINCIA: this.filtroProvincia || null,
        TIPO_ORDEN: this.filtroTipoOrden || null,
        PAGINA: i, TAMANO: this.pageSize
      }));
    }
    Promise.all(promesas).then((resultados: any[]) => {
      let todos = [];
      resultados.forEach(res => { if (res.rows) todos = todos.concat(res.rows); });
      const data = todos.map(r => ({
        'Orden': r.orden || '', 'Tipo Orden': r.tipo_orden || '', 'Fecha Cita': r.fecha_cita || '',
        'Locación': r.locacion || '', 'Técnico': r.tecnico || '', 'Tel. Técnico': r.tel_tecnico || '',
        'Supervisor': r.supervisor || '', 'Tel. Supervisor': r.tel_supervisor || '',
        'Contrata': r.contrata || '', 'Hora Salida': this.formatFecha(r.hora_salida),
        'Hora Sitio': this.formatFecha(r.hora_sitio), 'Hora Finaliza': this.formatFecha(r.hora_finaliza),
        'Tiempo en Sitio (min)': r.tiempo_en_sitio || 0, 'Fecha Llamada': this.formatFecha(r.fecha_llamada),
        'Tipo Contacto': r.tipo_contacto || '', 'Motivo': r.motivo || '', 'Resultado': r.resultado || '',
        'Estado Orden': r.estado_orden || '', 'Tipología': r.tipologia || '', 'Subtipología': r.subtipologia || '',
        'Observaciones': r.observaciones || '', 'Usuario': r.nombre_usuario || ''
      }));
      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Bitácora General');
      const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      saveAs(new Blob([buf], { type: 'application/octet-stream' }), 'Bitacora_General.xlsx');
    });
  }
}
